import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="copy-text"
export default class extends Controller {
  static targets = [ "input", "button" ]

  copy(event) {
    event.preventDefault();
    // Select the text field
    this.inputTarget.select();
    this.inputTarget.setSelectionRange(0, 99999); // For mobile devices

    // Copy the text inside the text field
    navigator.clipboard.writeText(this.inputTarget.value);
    this.buttonTarget.innerHTML = "Copied!";
  }
}
